require('./insurancesProfileDocumentationRow.scss');

const PropTypes = require('prop-types');
const React = require('react');

// @helpers
const { formatText, getLanguage } = require('core/i18n').i18n;

// @ commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { LabelDate } = require('commonsComponents/labelDate');

// @ constants
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');
const { DOCUMENT_TYPES: { BUDGET, POLICY, PRODUCT_INFORMATION, PRE_POLICY } } = require('../../../insuranceConstants/insuranceRequestHome');

const insuranceTypeKeys = {
    'HOME_INSURANCE': 'profileInsurances-homeInsurance',
    'MOBILE_INSURANCE': 'profileInsurances-insuranceMobile',
}
const docTypeKeys = {
    'POLICY': 'profileInsurances-policy',
    'BUDGET': 'profileInsurances-budget',
    'PRODUCT_INFORMATION': 'profileInsurances-productInformation',
    'PRE_POLICY': 'profileInsurances-prePolicy',
}

class InsurancesProfileDocumentationRow extends React.Component {
    constructor(props) {
        super(props);
    }

    insuranceTypeName() {
        const { insuranceTypeName } = this.props;

        return (
            <OKTableCell>
                {formatText(insuranceTypeKeys[insuranceTypeName])}
            </OKTableCell>
        )
    }

    buildDocumentTypeRow() {
        const { documentDesc } = this.props;
        const rowDocuments = documentDesc.map((singleDocument, index) => {
            if (
                singleDocument.documentType === BUDGET ||
                singleDocument.documentType === POLICY ||
                singleDocument.documentType === PRODUCT_INFORMATION ||
                singleDocument.documentType === PRE_POLICY
            ) {
                return (
                    <div
                        className="insurances-profile-documentation-row__internal-row insurances-profile-documentation-row__internal-row--align-vert"
                        key={`${index}-${singleDocument.idDocument}`}
                    >
                        {formatText(docTypeKeys[singleDocument.documentType])}
                    </div>
                )
            }
        });

        return (
            <OKTableCell>
                {rowDocuments}
            </OKTableCell>
        )
    }


    buildUrlRow() {
        const { documentDesc, policyCode, documentsFetch, callbackDownloadFile, documentDownloadingPolicyNumber } = this.props;

        const rowDocuments = documentDesc.map((singleDocument, index) => {
            const tooltipTarget = (
                <span>
                    <OKButton
                        modifier="task"
                        size="small"
                        loaderColor="dark"
                        loaderSize="small"
                        loading={documentDownloadingPolicyNumber === policyCode && documentsFetch.getIn([singleDocument.documentType, 'isFetching'])}
                        onClick={() => callbackDownloadFile(singleDocument.documentType, policyCode, singleDocument.policyVersion)}
                    >
                        <i className="icon icon-descargar" />
                    </OKButton>
                </span>
            );
            if (
                singleDocument.documentType === BUDGET ||
                singleDocument.documentType === POLICY ||
                singleDocument.documentType === PRODUCT_INFORMATION ||
                singleDocument.documentType === PRE_POLICY
            ) {
                return (
                    <div
                        className="insurances-profile-documentation-row__internal-row"
                        key={`${index}-${singleDocument.idDocument}`}
                    >
                        <OKTooltip
                            content="profileDocumentation-pdfTooltipDownload"
                            offset={[0, -30]}
                            target={tooltipTarget}
                            type="descriptive"
                        />
                    </div>
                )
            }
        });

        return (
            <OKTableCell>
                {rowDocuments}
            </OKTableCell>
        )
    }

    render() {
        const {
            date
        } = this.props;
        const dateCell = (
            <OKTableCell>
                <LabelDate
                    date={date}
                    language={getLanguage()}
                    today={LABEL_DATE_TODAY}
                    yesterday={LABEL_DATE_YESTERDAY}
                />
            </OKTableCell>
        );

        return (
            <OKTableRow>
                {dateCell}
                {this.insuranceTypeName()}
                {this.buildDocumentTypeRow()}
                {this.buildUrlRow()}
            </OKTableRow>
        );
    }
}

InsurancesProfileDocumentationRow.propTypes = {
    callbackDownloadFile: PropTypes.func,
    date: PropTypes.string.isRequired,
    insuranceTypeName: PropTypes.string,
    policyCode: PropTypes.string,
    documentDesc: PropTypes.object,
    documentDownloadingPolicyNumber: PropTypes.string,
    documentsFetch: PropTypes.object,
};

module.exports = InsurancesProfileDocumentationRow;
